import React from 'react';
import { Box, Container, Typography } from '@mui/material';

export default function PageHeader({ eyebrow, title, body }) {
  return (
    <Box
      component="section"
      sx={{
        pt: { xs: 7, md: 10 },
        pb: { xs: 5, md: 7 },
        borderBottom: '1px solid',
        borderColor: 'divider',
        position: 'relative'
      }}
    >
      <Box
        aria-hidden="true"
        className="alamen-grid-bg"
        sx={{
          position: 'absolute',
          inset: 0,
          opacity: 0.35,
          maskImage:
            'radial-gradient(900px 400px at 30% 0%, rgba(0,0,0,0.85), transparent 70%)',
          WebkitMaskImage:
            'radial-gradient(900px 400px at 30% 0%, rgba(0,0,0,0.85), transparent 70%)'
        }}
      />
      <Container maxWidth="xl" sx={{ position: 'relative' }}>
        {eyebrow ? (
          <Typography
            sx={{
              fontFamily: 'var(--font-mono)',
              fontSize: '0.72rem',
              textTransform: 'uppercase',
              letterSpacing: '0.14em',
              color: 'text.secondary',
              mb: 2
            }}
          >
            {eyebrow}
          </Typography>
        ) : null}
        <Typography
          component="h1"
          sx={{
            fontFamily: 'var(--font-serif)',
            fontSize: { xs: '2.6rem', md: '4.2rem' },
            lineHeight: 1.04,
            letterSpacing: '-0.025em',
            mb: body ? 2 : 0,
            maxWidth: 960
          }}
        >
          {title}
        </Typography>
        {body ? (
          <Typography sx={{ color: 'text.secondary', maxWidth: 720, fontSize: '1.08rem' }}>
            {body}
          </Typography>
        ) : null}
      </Container>
    </Box>
  );
}
